 
export default async (to, from, next) => {
    if(!to.params.slug){
       next({ name: 'province' });  
    }
    next(); 
}
